var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKbIconAlertError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7213 2.49964L18.6597 16.2496C18.7328 16.3763 18.7713 16.52 18.7713 16.6663C18.7713 16.8126 18.7328 16.9563 18.6597 17.083C18.5865 17.2096 18.4813 17.3148 18.3547 17.388C18.228 17.4611 18.0843 17.4996 17.938 17.4996H2.06134C1.91506 17.4996 1.77136 17.4611 1.64468 17.388C1.518 17.3148 1.41281 17.2096 1.33967 17.083C1.26653 16.9563 1.22803 16.8126 1.22803 16.6663C1.22803 16.52 1.26653 16.3763 1.33967 16.2496L9.278 2.49964C9.35115 2.37296 9.45635 2.26778 9.58302 2.19464C9.7097 2.12151 9.8534 2.08301 9.99967 2.08301C10.1459 2.08301 10.2896 2.12151 10.4163 2.19464C10.543 2.26778 10.6482 2.37296 10.7213 2.49964ZM9.16634 13.333V14.9996H10.833V13.333H9.16634ZM9.16634 7.49964V11.6663H10.833V7.49964H9.16634Z",
    fill: "#CD3746"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbIconAlertError);
export default __webpack_public_path__ + "static/media/KB-icon-alert-error.e6e9233ac88f2251f612d8ff11ad3d60.svg";
export { ForwardRef as ReactComponent };